export default "__VITE_ASSET__D_r$DKB___"